<template>
        <td class="table-cell" v-if="action !='show' && (tariff.type == 'subscription')">
            <input
              type="text"
              step="0.01"
              :name="input_name"
              :disabled="action == 'refill'"
              @change="changeValue($event, tariff)"
              :value="getInputFormatedValue(tariff[model_prop])"
              :readonly="tariff_readonly"
              class="form-control exchange_field">
            <span class="text-danger"
              v-if="is_valid">
              {{__("wrong_value")}}
            </span>
        </td>
        <td v-else-if="!read_only" class="prices-disabled"></td>
        <td v-else>
          <span v-if="tariff.type == 'subscription'">{{ formatValue(tariff[model_prop])}}</span>
          <span v-else><i class="fas fa-minus"></i></span>
        </td>
</template>

<script>
    import {Fragment} from 'vue-fragment';
    import {Money} from './../../../services/Money.js';
    import Utils from './../../../services/Utils.js';
    import {EventBus} from './../../../views/price-list/EventBus';

    export default {
        components : {
          Fragment,
        },
        data() {
          return {
            money: new Money(),
            is_valid:false,
            is_validated_form:false
          }
        },
        props : [
          'tariff',
          'validated_form',
          'read_only',
          'input_name',
          'model_prop',
          'action',
            'tariff_readonly'
        ],
       methods: {
          validateForm () {
             this.is_valid =  this.is_validated_form && (this.tariff[this.model_prop] === '' || (this.isEmpty(this.tariff[this.model_prop]) || this.tariff[this.model_prop] < 0));
          },
          changeValue(e, tariff) {
                let value = this.money.normalize(e.target.value);
                if (value != NaN && value >= 0 && value != '') {
                  tariff[this.$props.model_prop]  = this.money.normalize(e.target.value);
                  e.target.value = this.money.format(e.target.value);
                } else {
                  e.target.value = '';
                  tariff[this.$props.model_prop]  = '';
                }
                this.validateForm();
          },
          getInputFormatedValue(value) {
            let formated = ''
            if (value != NaN && value >= 0 && value !== '') {
              formated = this.money.format(value);
            }
            return formated;
          },
          isEmpty(value) {
              return Utils.isEmpty(value);
          },
          formatValue(value) {
            return this.money.localize(value);
          }
       },
       mounted () {
         this.is_validated_form = this.validated_form;
         EventBus.$on('validate_test', (e) => {
            this.is_validated_form = e;
            this.validateForm()
           });
       },

    }
</script>

<style lang="scss" scoped>

</style>
